<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-form heroicon heroicons-lg"
  >
    <path
      class="heroicon-form-clipboard heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M0 16.01A6 6 0 0 1 6 10h66a6 6 0 0 1 6 6.01v77.98a6 6 0 0 1-6 6.01H6a6 6 0 0 1-6-6.01V16.01z"
    ></path>
    <polygon
      class="heroicon-form-pages heroicon-component-fill"
      fill="#FFFFFF"
      points="7 14 7 90 71 90 71 14"
    ></polygon>
    <path
      class="heroicon-form-clip heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M24 8.9a39.7 39.7 0 0 1 7.1-2.12 8 8 0 0 1 15.8 0c2.46.5 4.83 1.2 7.1 2.13V19H24V8.9zM39 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    ></path>
    <polygon
      class="heroicon-form-pen-housing heroicon-component-fill"
      fill="#FFFFFF"
      points="90 22 99 22 99 25 96 25 96 79 93 90 90 79"
    ></polygon>
    <path
      class="heroicon-form-pen-button heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M90 15h5v7s4-.24 4 0v3h-9V15z"
    ></path>
    <rect
      class="heroicon-form-pen-grip heroicon-component-accent heroicon-component-fill"
      width="6"
      height="24"
      x="90"
      y="55"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M23 20h32v2H23v-2zM9 85h60v3H9v-3zM6 98a3.99 3.99 0 0 1-3.55-2.16c1 .73 2.22 1.16 3.54 1.16h66.02c1.32 0 2.55-.43 3.54-1.16A4 4 0 0 1 72.01 98H5.99z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M55 9.33V10h17.16A6 6 0 0 1 78 16V93.99a6 6 0 0 1-6 6.01H6a6 6 0 0 1-6-6.01V16a6 6 0 0 1 6-6h17v-.67a39.7 39.7 0 0 1 8.1-2.55 8 8 0 0 1 15.8 0A39.7 39.7 0 0 1 55 9.33zM55 14h16v76H7V14h16v-2H6a4 4 0 0 0-4 4.01V94c.91 1.22 2.36 2 4 2h66c1.64 0 3.09-.78 4-2V16.01A4 4 0 0 0 72 12H55v2zM9 16v67h60V16H55v4H23v-4H9zm10.5 47a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm1.5-2.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm5-.5h24v1H26v-1zm35 7v1H17v-1h44zm-20 6v1H17v-1h24zm-24-3h40v1H17v-1zm40-41v1H17v-1h40zm-40 3h42v1H17v-1zm24 3v1H17v-1h24zM25 17v1h28v-1H25zm0-1h28v-5.34a37.7 37.7 0 0 0-6.49-1.92l-1.37-.27-.2-1.39a6 6 0 0 0-11.87 0l-.21 1.39-1.37.27A37.7 37.7 0 0 0 25 10.66V16zm14-5a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm2-3a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM6 98h66a4 4 0 0 0 3.55-2.16A5.96 5.96 0 0 1 72.01 97H5.99a5.96 5.96 0 0 1-3.54-1.16c.67 1.28 2 2.16 3.54 2.16zm63-13H9v1h35v1H9v1h60v-1h-6v-1h6v-1zm21-69v-2h6v7h2a2 2 0 0 1 2 2v18a1 1 0 1 1-2 0V26h-1v53l-3 12h-2l-3-12V21h1v-5zm4 0h-2v5h2v-5zm-3 8h7v-1h-7v1zm4 1h-4v30h4V25zm-4 32h4v-1h-4v1zm4 20h-4v1h4v-1zm-2 9.75L94.94 79h-3.88L93 86.75zM95 76V58h-4v18h4zM26 54h24v1H26v-1zm-6.5 3a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm1.5-2.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm5-6.5h24v1H26v-1zm-6.5 3a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm1.5-2.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm5-6.5h24v1H26v-1zm-4 .5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM19.5 44a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 26h44v1H17v-1z"
    ></path>
  </svg>
</template>
